<template>
  <section class="card-set-information" v-if="card.setInformation">
    <h4 class="secondary-font">Set Information</h4>

    <p v-html="card.setInformation" />
  </section>
</template>

<script>
export default {
  props: {
    card: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-set-information {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}
</style>
